import actions from "./actions";

const setUser = payload => {
  const user = payload || null;
  const action = actions.setUser(user);
  return action;
};

export default {
  setUser,
};



// WEBPACK FOOTER //
// ./src/state/auth/operations.js